<template>
  <div>
    <country-list></country-list>
  </div>
</template>

<script>

export default {
}
</script>